/**
 * Parse a string of accession numbers into an array of unique accessions.
 *
 * @param input - comma or newline separated string of accessions
 * @returns array of unique, trimmed accession strings
 */
export function parseAccessions(input: string): string[] {
  return input
    .split(/[\n,]+/)
    .map((s) => s.trim())
    .filter((s) => s.length > 0)
    .filter((s, i, arr) => arr.indexOf(s) === i);
}
